// Quiz Configuration Data
const quizData = {
  questions: [
    {
      id: 1,
      group: "general",
      question: "How old is your dog?",
      answers: [
        { text: "0 - 6 months", score: 0 },
        { text: "7 - 12 months", score: 1 },
        { text: "1 - 2 years", score: 2 },
        { text: "2 - 7 years", score: 3 },
        { text: "More than 7 years", score: 4 },
      ]
    },
    {
      id: 2,
      group: "general",
      type: "text",
      question: "What is your dog's name?",
      placeholder: "Name"
    },
    {
      id: 3,
      group: "general",
      type: "text",
      question: "What breed is {dogName}?",
      placeholder: "Mix, Retriever, Pitbull..."
    },
    {
      id: 4,
      group: "general",
      question: "{dogName}'s training experience?",
      answers: [
        { text: "Group class", score: 0 },
        { text: "Private instructor", score: 1 },
        { text: "I trained at home", score: 2 },
        { text: "No training experience yet", score: 3 },
      ]
    },
    {
      id: 5,
      group: "general",
      question: "Social behavior",
      subtitle: "We understand it depends, but what is the most common state?",
      answers: [
        { text: "Sweet & social", score: 0 },
        { text: "Quiet & warm", score: 1 },
        { text: "Very shy", score: 2 },
        { text: "Fear biter", score: 3 },
      ]
    },
    {
      id: 6,
      group: "potty",
      sectionTitle: "Potty Training",
      question: "Does your dog regularly do its business outside?",
      answers: [
        { text: "Always – My dog always goes to the bathroom outside.", score: 0 },
        { text: "Mostly – My dog goes outside most of the time but has occasional accidents.", score: 1 },
        { text: "Rarely – My dog struggles to go to the bathroom outside and frequently has accidents indoors.", score: 2 },
        { text: "Never – My dog does not go to the bathroom outside. biter", score: 3 },
      ]
    },
    {
      id: 7,
      group: "potty",
      sectionTitle: "Potty Training",
      question: "How often does your dog have accidents indoors?",
      answers: [
        { text: "Never – My dog never has accidents indoors.", score: 0 },
        { text: "Rarely – Maybe once a month or less.", score: 1 },
        { text: "Sometimes – A few times a month.", score: 2 },
        { text: "Often – Multiple times a week.", score: 3 },
        { text: "Always – Every day.", score: 4 },
      ]
    },
    {
      id: 8,
      group: "potty",
      sectionTitle: "Potty Training",
      question: "Does your dog signal when it needs to go outside?",
      answers: [
        { text: "Always – My dog has a clear signal to go outside.", score: 0 },
        { text: "Sometimes – My dog signals sometimes, but not consistently.", score: 1 },
        { text: "Rarely – It's very rare for my dog to signal needing to go outside.", score: 2 },
        { text: "Never – My dog does not signal at all.", score: 3 },
      ]
    },
    {
      id: 9,
      group: "reactivity",
      sectionTitle: "Reactivity",
      question: "How does your dog react to other dogs or people on walks?",
      answers: [
        { text: "Calmly – My dog remains calm and ignores them.", score: 0 },
        { text: "Curious – My dog shows interest but remains manageable.", score: 1 },
        { text: "Anxious – My dog appears nervous or anxious but does not react aggressively.", score: 2 },
        { text: "Reactive – My dog barks, growls, or pulls towards them.", score: 3 },
      ]
    },
    {
      id: 10,
      group: "reactivity",
      sectionTitle: "Reactivity",
      question: "Does your dog bark or lunge at various triggers (people, animals, vehicles)?",
      answers: [
        { text: "Never – My dog does not react to these triggers.", score: 0 },
        { text: "Rarely – My dog might react if the trigger is very close or surprising.", score: 1 },
        { text: "Sometimes – My dog reacts to certain triggers but not consistently.", score: 2 },
        { text: "Often – My dog frequently barks or lunges at these triggers.", score: 3 },
      ]
    },
    {
      id: 11,
      group: "reactivity",
      sectionTitle: "Reactivity",
      question: "Can you redirect your dog's attention away from these triggers?",
      answers: [
        { text: "Always – I can easily get my dog to focus on me instead of the trigger.", score: 0 },
        { text: "Sometimes – I can redirect my dog's attention, but it takes effort.", score: 1 },
        { text: "Rarely – It's very difficult to redirect my dog's attention away from triggers.", score: 2 },
        { text: "Never – I cannot get my dog to disengage from the triggers.", score: 3 },
      ]
    },
    {
      id: 12,
      group: "separation",
      sectionTitle: "Separation Anxiety",
      question: "Does your dog show signs of distress when you prepare to leave?",
      answers: [
        { text: "No signs – My dog remains calm during my departure preparations.", score: 0 },
        { text: "Mild signs – My dog becomes slightly anxious (pacing, whining) but is otherwise manageable.", score: 1 },
        { text: "Noticeable signs – My dog shows clear signs of distress (barking, howling, excessive salivation).", score: 2 },
        { text: "Severe signs – My dog becomes extremely distressed (attempts to escape, self-injury).", score: 3 },
      ]
    },
    {
      id: 13,
      group: "separation",
      sectionTitle: "Separation Anxiety",
      question: "Have you noticed destructive behavior (scratching doors, chewing furniture) when your dog is alone?",
      answers: [
        { text: "Never – My dog has not displayed any destructive behavior when alone.", score: 0 },
        { text: "Rarely – There have been one or two incidents of minor destructive behavior.", score: 1 },
        { text: "Sometimes – My dog occasionally exhibits destructive behavior when alone.", score: 2 },
        { text: "Often – My dog frequently exhibits destructive behavior when left alone.", score: 3 },
      ]
    },
    {
      id: 14,
      group: "separation",
      sectionTitle: "Separation Anxiety",
      question: "How does your dog react within the first hour after you leave?",
      answers: [
        { text: "Calmly – My dog settles down quickly after I leave.", score: 0 },
        { text: "Anxiously but settles – My dog is anxious at first but calms down within the first hour.", score: 1 },
        { text: "Continuous anxiety – My dog remains anxious and unsettled for the entire hour.", score: 2 },
        { text: "Escalating anxiety – My dog's anxiety seems to increase, leading to destructive behavior or loud vocalizations.", score: 3 },
      ]
    },
    {
      id: 15,
      group: "crate",
      sectionTitle: "Crate Training",
      question: "Are you using the crate?",
      answers: [
        { text: "Yes", score: 0 },
        { text: "No, but I would like to", score: 0 },
        { text: "No, and I don’t want to", score: 0 },
      ]
    },
    {
      id: 16,
      group: "crate",
      sectionTitle: "Crate Training",
      question: "Does your dog willingly enter its crate?",
      answers: [
        { text: "Always – My dog enters the crate on command or happily goes in on its own.", score: 0 },
        { text: "Sometimes – My dog will enter the crate with some encouragement or treats.", score: 1 },
        { text: "Rarely – My dog resists entering the crate and needs significant coaxing.", score: 2 },
        { text: "Never – My dog refuses to enter the crate under any circumstances.", score: 3 },
      ]
    },
    {
      id: 17,
      group: "crate",
      sectionTitle: "Crate Training",
      question: "Can your dog remain calm and quiet in the crate for extended periods?",
      answers: [
        { text: "Always – My dog remains calm and can be crated for several hours without issue.", score: 0 },
        { text: "Mostly – My dog is generally calm but may become restless after a while.", score: 1 },
        { text: "Rarely – My dog is often anxious or noisy when crated for more than a short period.", score: 2 },
        { text: "Never – My dog is constantly stressed, vocal, or attempts to escape the crate.", score: 3 },
      ]
    },
    {
      id: 18,
      group: "crate",
      sectionTitle: "Crate Training",
      question: "Have you used the crate for timeout or punishment?",
      answers: [
        { text: "Never – The crate is only associated with positive experiences.", score: 0 },
        { text: "Rarely – I've used the crate for timeouts a few times but not as a punishment.", score: 1 },
        { text: "Sometimes – The crate has been used for timeouts or mild punishment occasionally.", score: 2 },
        { text: "Often – The crate is regularly used as a method of punishment.", score: 3 },
      ]
    },
    {
      id: 19,
      group: "recall",
      sectionTitle: "Recall Training",
      question: "Does your dog come when called, regardless of distractions?",
      answers: [
        { text: "Always – My dog comes when called every time, no matter what.", score: 0 },
        { text: "Mostly – My dog comes when called, except when highly distracted.", score: 1 },
        { text: "Rarely – My dog struggles to come when called if there are any distractions.", score: 2 },
        { text: "Never – My dog does not come when called if distracted.", score: 3 },
      ]
    },
    {
      id: 20,
      group: "recall",
      sectionTitle: "Recall Training",
      question: "How often do you practice recall commands?",
      answers: [
        { text: "Daily – We practice recall commands every day.", score: 0 },
        { text: "Weekly – We have recall training sessions once a week.", score: 1 },
        { text: "Occasionally – We practice recall commands now and then, without a set schedule.", score: 2 },
        { text: "Rarely – We rarely or never practice recall commands.", score: 3 },
      ]
    },
    {
      id: 21,
      group: "recall",
      sectionTitle: "Recall Training",
      question: "Is your dog's recall reliable in both familiar and unfamiliar environments?",
      answers: [
        { text: "Yes – My dog's recall is reliable, no matter where we are.", score: 0 },
        { text: "Mostly in familiar environments – My dog responds well at home or in familiar places but struggles in new locations.", score: 1 },
        { text: "Mostly in unfamiliar environments – My dog is more attentive and responsive in new or unusual settings.", score: 2 },
        { text: "No – My dog's recall is not reliable in any environment.", score: 3 },
      ]
    },
    {
      id: 22,
      group: "scavenging",
      sectionTitle: "Scavenging",
      question: "Does your dog pick up and eat things off the ground outside?",
      answers: [
        { text: "Never – My dog never picks up or eats things from the ground.", score: 0 },
        { text: "Rarely – My dog occasionally picks things up but doesn’t always eat them.", score: 1 },
        { text: "Sometimes – My dog often picks up items but will drop them with instruction.", score: 2 },
        { text: "Frequently – My dog consistently picks up and eats items from the ground, regardless of commands.", score: 3 },
      ]
    },
    {
      id: 23,
      group: "scavenging",
      sectionTitle: "Scavenging",
      question: "How does your dog react to being told to \"leave it\" or \"drop it\"?",
      answers: [
        { text: "Always complies – My dog always obeys these commands immediately.", score: 0 },
        { text: "Usually complies – My dog often obeys, but may need a moment or extra encouragement.", score: 1 },
        { text: "Rarely complies – My dog struggles to obey these commands, especially with high-value items.", score: 2 },
        { text: "Never complies – My dog ignores these commands and continues with its behavior.", score: 3 },
      ]
    },
    {
      id: 24,
      group: "scavenging",
      sectionTitle: "Scavenging",
      question: "Have you experienced difficulty in taking objects away from your dog?",
      answers: [
        { text: "Never – I can always take things away without any issue.", score: 0 },
        { text: "Rarely – Occasionally, my dog resists giving up an item, but it's not a significant problem.", score: 1 },
        { text: "Sometimes – It's often a struggle to get my dog to release items, with some success.", score: 2 },
        { text: "Frequently – It's almost always difficult to take items away, leading to a tug-of-war or avoidance.", score: 3 },
      ]
    },
    {
      id: 25,
      group: "leash",
      sectionTitle: "Leash Pulling",
      question: "Does your dog pull on the leash during walks?",
      answers: [
        { text: "Never – My dog never pulls on the leash.", score: 0 },
        { text: "Rarely – My dog pulls on the leash occasionally but is generally manageable.", score: 1 },
        { text: "Sometimes – My dog pulls on the leash fairly often, especially when excited or distracted.", score: 2 },
        { text: "Always – My dog constantly pulls on the leash, making walks difficult.", score: 3 },
      ]
    },
    {
      id: 26,
      group: "leash",
      sectionTitle: "Leash Pulling",
      question: "How do you currently manage or correct leash pulling?",
      answers: [
        { text: "Positive reinforcement – I use treats or praise to encourage walking nicely.", score: 0 },
        { text: "Stop-and-go / Change direction – I stop walking or change direction when my dog pulls.", score: 1 },
        { text: "Choosing calm environments – I opt to walk in quiet, less stimulating areas to prevent pulling and keep my dog focused.", score: 2 },
        { text: "I struggle to manage it – I haven’t found a method that effectively stops the pulling.", score: 3 },
      ]
    },
    {
      id: 27,
      group: "leash",
      sectionTitle: "Leash Pulling",
      question: "Does your dog pay attention to you on walks, or is it focused on the environment?",
      answers: [
        { text: "Always pays attention to me – My dog focuses on me and easily follows commands.", score: 0 },
        { text: "Mostly pays attention – My dog checks in with me but is also interested in the environment.", score: 1 },
        { text: "Mostly focused on the environment – My dog is occasionally responsive but mostly distracted.", score: 2 },
        { text: "Always focused on the environment – My dog ignores me and is completely focused on surroundings.", score: 3 },
      ]
    },
    {
      id: 28,
      group: "attention",
      sectionTitle: "Attention Seeking",
      question: "Does your dog engage in behaviors like barking or nudging for attention?",
      answers: [
        { text: "Never – My dog does not exhibit these behaviors for attention.", score: 0 },
        { text: "Rarely – My dog occasionally displays these behaviors when wanting attention.", score: 1 },
        { text: "Sometimes – My dog regularly seeks attention through barking, nudging, or other behaviors.", score: 2 },
        { text: "Often – My dog constantly uses these behaviors to gain attention.", score: 3 },
      ]
    },
    {
      id: 29,
      group: "attention",
      sectionTitle: "Attention Seeking",
      question: "How do you respond to these attention-seeking behaviors?",
      answers: [
        { text: "Ignore the behavior until it stops, then provide attention.", score: 0 },
        { text: "Provide immediate attention to stop the behavior.", score: 1 },
        { text: "Tell the dog \"no\" or use a deterrent to stop the behavior.", score: 2 },
        { text: "Redirect the behavior with a toy, task, or command.", score: 3 },
      ]
    },
    {
      id: 30,
      group: "attention",
      sectionTitle: "Attention Seeking",
      question: "Does your dog continue to seek attention even after being told \"no\"?",
      answers: [
        { text: "Never – My dog stops immediately and does not repeat the behavior.", score: 0 },
        { text: "Rarely – My dog usually stops but may try again later.", score: 1 },
        { text: "Sometimes – My dog may pause but often repeats the behavior after a short time.", score: 2 },
        { text: "Often – My dog persists in seeking attention despite being told \"no\".", score: 3 },
      ]
    },
    {
      id: 31,
      group: "bond",
      sectionTitle: "Strong Bond",
      question: "Do you engage in daily play and training sessions with your dog?",
      answers: [
        { text: "Always – We have daily sessions without fail.", score: 0 },
        { text: "Mostly – We engage in play and training most days.", score: 1 },
        { text: "Occasionally – We have sessions a few times a week.", score: 2 },
        { text: "Rarely – We rarely have these sessions.", score: 3 },
      ]
    },
    {
      id: 32,
      group: "bond",
      sectionTitle: "Strong Bond",
      question: "How does your dog respond to your commands and cues?",
      answers: [
        { text: "Immediately and accurately every time.", score: 0 },
        { text: "Generally well, but may need occasional repetition.", score: 1 },
        { text: "Inconsistently, with frequent need for repetition or correction.", score: 2 },
        { text: "Rarely responds, showing confusion or disregard for commands.", score: 3 },
      ]
    },
    {
      id: 33,
      group: "bond",
      sectionTitle: "Strong Bond",
      question: "Do you feel your dog trusts and understands you?",
      answers: [
        { text: "Completely – There's a strong mutual trust and understanding.", score: 0 },
        { text: "Mostly – There's a good level of trust and understanding, with room for improvement.", score: 1 },
        { text: "Somewhat – Trust and understanding are present but not consistently.", score: 2 },
        { text: "Rarely – It's challenging to feel a sense of trust or understanding between us.", score: 3 },
      ]
    },
    {
      id: 34,
      group: "bed",
      sectionTitle: "Keep A Dog Off Bed",
      question: "Do you allow your dog to chill on bed or sofa?",
      answers: [
        { text: "Yes, and I like it", score: 0 },
        { text: "Yes, but I want to change that", score: 0 },
        { text: "No", score: 0 },
      ]
    },
    {
      id: 35,
      group: "bed",
      sectionTitle: "Keep A Dog Off Bed",
      question: "Does your dog jump on your bed without permission?",
      answers: [
        { text: "Never – My dog never jumps on the bed without permission.", score: 0 },
        { text: "Rarely – My dog may jump on the bed occasionally but knows it's not allowed.", score: 1 },
        { text: "Sometimes – My dog often jumps on the bed, even though it's discouraged.", score: 2 },
        { text: "Always – My dog consistently jumps on the bed without regard for permission.", score: 3 },
      ]
    },
    {
      id: 36,
      group: "bed",
      sectionTitle: "Keep A Dog Off Bed",
      question: "Have you set clear rules about where your dog is allowed to sleep?",
      answers: [
        { text: "Yes, and my dog follows these rules consistently.", score: 0 },
        { text: "Yes, but my dog doesn't always follow the rules.", score: 1 },
        { text: "I've tried, but the rules are not consistently enforced or followed.", score: 2 },
        { text: "No, I haven't set clear rules about where my dog is allowed to sleep.", score: 3 },
      ]
    },
    {
      id: 37,
      group: "bed",
      sectionTitle: "Keep A Dog Off Bed",
      question: "Does your dog have a comfortable and appealing bed of its own?",
      answers: [
        { text: "Yes, and my dog loves it and uses it regularly.", score: 0 },
        { text: "Yes, but my dog doesn't use it much.", score: 1 },
        { text: "My dog has a bed, but it might not be the most appealing to them.", score: 2 },
        { text: "No, my dog doesn't have a bed of its own.", score: 3 },
      ]
    },
    {
      id: 38,
      group: "socialization",
      sectionTitle: "Socialization",
      question: "How does your dog behave around unfamiliar people and dogs?",
      answers: [
        { text: "Very friendly – My dog is always eager to greet new people and dogs.", score: 0 },
        { text: "Cautiously curious – My dog approaches new people and dogs with some hesitation but is generally friendly.", score: 1 },
        { text: "Reserved – My dog is hesitant and tends to keep a distance from unfamiliar people and dogs.", score: 2 },
        { text: "Aggressive or fearful – My dog reacts negatively (barking, growling, or hiding) to new people and dogs.", score: 3 },
      ]
    },
    {
      id: 39,
      group: "socialization",
      sectionTitle: "Socialization",
      question: "Has your dog been exposed to various environments and situations?",
      answers: [
        { text: "Extensively – My dog has been exposed to many different environments and situations and handles them well.", score: 0 },
        { text: "Moderately – My dog has been exposed to some new environments and situations but not regularly.", score: 1 },
        { text: "Minimally – My dog has had limited exposure to new environments and situations.", score: 2 },
        { text: "Not at all – My dog has had very little to no exposure to unfamiliar environments and situations.", score: 3 },
      ]
    },
    {
      id: 40,
      group: "socialization",
      sectionTitle: "Socialization",
      question: "How does your dog respond to new experiences?",
      answers: [
        { text: "Very positively – My dog is always excited and eager for new experiences.", score: 0 },
        { text: "With some caution but adapts quickly – My dog may be initially hesitant but usually adjusts well.", score: 1 },
        { text: "With noticeable stress or anxiety – My dog seems stressed or anxious but can eventually adapt with support.", score: 2 },
        { text: "With extreme fear or aggression – My dog does not handle new experiences well, reacting with fear or aggression.", score: 3 },
      ]
    },
    {
      id: 41,
      group: "jumping",
      sectionTitle: "Jumping",
      question: "Does your dog jump on you or visitors?",
      answers: [
        { text: "Never – My dog never jumps on people.", score: 0 },
        { text: "Rarely – My dog occasionally jumps up but not often.", score: 1 },
        { text: "Sometimes – My dog jumps on people fairly frequently, especially when excited.", score: 2 },
        { text: "Always – My dog constantly jumps on me and visitors without fail.", score: 3 },
      ]
    },
    {
      id: 42,
      group: "jumping",
      sectionTitle: "Jumping",
      question: "Have you tried any methods to reduce or prevent jumping?",
      answers: [
        { text: "Yes, successfully – I've implemented training techniques that have effectively stopped the jumping.", score: 0 },
        { text: "Yes, but with limited success – I've tried several methods, but none have completely stopped the behavior.", score: 1 },
        { text: "Yes, but unsuccessfully – Attempts to curb the behavior have had no noticeable effect.", score: 2 },
        { text: "No, I haven't tried any specific methods to prevent jumping.", score: 3 },
      ]
    },
    {
      id: 43,
      group: "jumping",
      sectionTitle: "Jumping",
      question: "How does your dog greet people?",
      answers: [
        { text: "Calmly, with little to no physical contact.", score: 0 },
        { text: "Excitedly, but listens to commands to calm down.", score: 1 },
        { text: "Overly excitedly, with difficulty controlling the behavior.", score: 2 },
        { text: "Aggressively or fearfully, with behaviors like barking, growling, or retreating.", score: 3 },
      ]
    },
    {
      id: 44,
      group: "biting",
      sectionTitle: "Biting",
      question: "How often does your dog engage in biting or mouthing behavior?",
      answers: [
        { text: "Never – My dog does not bite or mouth at all.", score: 0 },
        { text: "Rarely – My dog occasionally mouths, especially during play, but it's gentle and controlled.", score: 1 },
        { text: "Sometimes – My dog often mouths or nibbles, particularly when excited or seeking attention.", score: 2 },
        { text: "Frequently – My dog regularly engages in biting or mouthing, beyond typical playful behavior.", score: 3 },
      ]
    },
    {
      id: 45,
      sectionTitle: "Biting",
      group: "biting",
      question: "What triggers your dog's biting or mouthing behavior?",
      answers: [
        { text: "No triggers – Biting or mouthing is not an issue with my dog.", score: 0 },
        { text: "Play and excitement – My dog tends to bite or mouth during play or when very excited.", score: 1 },
        { text: "Fear or discomfort – My dog bites or mouths when scared, anxious, or uncomfortable.", score: 2 },
        { text: "Seeking attention – My dog uses biting or mouthing as a way to seek attention.", score: 3 },
      ]
    },
    {
      id: 46,
      sectionTitle: "Biting",
      group: "biting",
      question: "How do you respond to your dog's biting or mouthing?",
      answers: [
        { text: "Redirection – I redirect my dog's biting to a toy or chewable item.", score: 0 },
        { text: "Training commands – I use commands like \"no bite\" and reward non-biting behavior.", score: 1 },
        { text: "Time-outs – My dog receives a time-out to calm down after biting.", score: 2 },
        { text: "Seeking help – I'm consulting a professional to address biting behavior.", score: 3 },
      ]
    },
  ],
};
